import React from 'react';

import { TSvgIcon } from '../types';

export const DeleteIcon: TSvgIcon = ({ color = '#00D9DE', width = 16, height = 16 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.99967 12.6667C3.99967 13.4 4.59967 14 5.33301 14H10.6663C11.3997 14 11.9997 13.4 11.9997 12.6667V6C11.9997 5.26667 11.3997 4.66667 10.6663 4.66667H5.33301C4.59967 4.66667 3.99967 5.26667 3.99967 6V12.6667ZM5.99967 6H9.99967C10.3663 6 10.6663 6.3 10.6663 6.66667V12C10.6663 12.3667 10.3663 12.6667 9.99967 12.6667H5.99967C5.63301 12.6667 5.33301 12.3667 5.33301 12V6.66667C5.33301 6.3 5.63301 6 5.99967 6ZM10.333 2.66667L9.85967 2.19333C9.73967 2.07333 9.56634 2 9.39301 2H6.60634C6.43301 2 6.25967 2.07333 6.13967 2.19333L5.66634 2.66667H3.99967C3.63301 2.66667 3.33301 2.96667 3.33301 3.33333C3.33301 3.7 3.63301 4 3.99967 4H11.9997C12.3663 4 12.6663 3.7 12.6663 3.33333C12.6663 2.96667 12.3663 2.66667 11.9997 2.66667H10.333Z"
                fill={color}
            />
        </svg>
    );
};
